import React from 'react';
import { Button } from '@/components/ui/button';
import { finalCTAData } from '@/data/mock';
import { ArrowRight } from 'lucide-react';

export const FinalCTASection = ({ onBookDemo }) => {
  return (
    <section className="relative py-24 bg-slate-950">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-cyan-500/10 to-indigo-500/10 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-3xl p-8 md:p-16 text-center">
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-3xl overflow-hidden">
            <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2/3 h-1 bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" />
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {finalCTAData.headline}
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto">
            {finalCTAData.subtext}
          </p>
          
          <Button
            onClick={onBookDemo}
            size="lg"
            className="bg-gradient-to-r from-cyan-500 to-indigo-500 hover:from-cyan-400 hover:to-indigo-400 text-white border-0 shadow-lg shadow-cyan-500/25 text-base px-10 py-6"
          >
            {finalCTAData.cta}
            <ArrowRight size={18} className="ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};
